export default "__VITE_ASSET__a7f251f9__"